import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './styles/globals.css';

// Extract OAuth token from URL fragment BEFORE React renders
// This runs once, synchronously, on page load
const hash = window.location.hash;
if (hash.includes('token=')) {
  const token = hash.split('token=')[1]?.split('&')[0];
  if (token) {
    localStorage.setItem('hatmail_token', token);
    // Clean the URL without triggering a reload
    window.history.replaceState(null, '', window.location.pathname);
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchInterval: 60_000,
      retry: 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
